import { useAuraSupportInfo } from "src/Utils/Hooks/UseAuraInfoContext";
import { IUser } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import ProfileIcon from "src/SharedComponents/ProfileIcon/ProfileIcon";
import useSortableData, { SortConfig } from "src/Utils/Hooks/SortableData/useSortableData";
import TableHead from "src/SharedComponents/Table/TableHead";

const Users: React.FC = () => {
  let conf: SortConfig<IUser> = {
      key: 'firstName',
      direction: 'ascending'
  };

  const { adminDetails } = useAuraSupportInfo();

  const sortUsers = (list: IUser[] | undefined) => {
    list?.sort((a, b) => {
      // Check for null or undefined firstName and move them to the top
      if (a.firstName === null || a.firstName === undefined) return -1;
      if (b.firstName === null || b.firstName === undefined) return 1;
      return a.firstName.localeCompare(b.firstName);
    })
    return list;
  }

  const sortedUsers = sortUsers(adminDetails?.users) || [];
  const { items, requestSort, sortConfig } = useSortableData(sortedUsers, conf);
  
  return (
      <>
        <div className='row mt-5'>
          <div className={`${tableStyles.fixTableHead} ${tableStyles.roundedTable}`}>
            {adminDetails?.users &&
              <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                <thead className={`${tableStyles.tableHead}`}>
                  <tr key={'header'}>
                    <th></th>
                    <TableHead<IUser>
                      columnName="First Name" 
                      requestSort={requestSort}
                      sortConfig={sortConfig}
                      columnkey="firstName"
                    />
                    <th className={tableStyles.heading}>Last Name</th>
                    <th className={tableStyles.heading}>E-Mail</th>
                    <th className={tableStyles.heading}></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((user) => (
                    <tr key={user.email}>
                      <td>
                        <ProfileIcon
                          firstName={user.firstName}
                          lastName={user.lastName}
                        />
                      </td>
                      <td className={tableStyles.data} style={{fontWeight: 600}}>
                        {user.firstName? user.firstName : ''}
                      </td>
                      <td className={tableStyles.data} style={{fontWeight: 600}}>
                        {user.lastName? user.lastName : ''}
                      </td>
                      <td className={tableStyles.data}>{user.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            }
          </div>
      </div>
      </>
  )
}
export default Users;